// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__eFLXi","cell":"ColumnAccessor_cell__1Sn_n","firstCellAccent":"ColumnAccessor_firstCellAccent__3EZ6J"};